import appConfig from '../config';

export async function commandUpdateSiteConfig(backendFetch, siteId, config) {
    const f = await backendFetch(appConfig.REACT_APP_HOST + "/api/v2/command/set-config/" + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({"updates": Object.values(config)})
    })
    return await f.json()
}

export async function commandFetchOverrides(backendFetch, siteId, online) {
    if (!siteId) return
    if (online !== 1) return
    const response = await backendFetch(appConfig.REACT_APP_HOST + "/api/v2/command/generic/" + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
            type: "state",
            data: {"state_index": "overrides"}
        })
    })
    const jsonResponse = await response.json()
    return jsonResponse.overrides_state;
}

export async function uploadConfig(backendFetch, siteId) {
    const f = await backendFetch(appConfig.REACT_APP_HOST + '/api/v2/command/generic/' + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({type: "config_upload"})
    })
    const r = await f.json()
    return r
}

export async function scanDevices(backendFetch, siteId) {
    const f = await backendFetch(appConfig.REACT_APP_HOST + '/api/v2/command/generic/' + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({type: "devices_scan", data: {timeout: 30}})
    })
    const r = await f.json()
    return r
}

export async function uploadDevices(backendFetch, siteId) {
    const f = await backendFetch(appConfig.REACT_APP_HOST + '/api/v2/command/generic/' + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({type: "devices_upload"})
    })
    const r = await f.json()
    return r

}

export async function reboot(backendFetch, siteId, tag = "") {
    const f = await backendFetch(appConfig.REACT_APP_HOST + '/api/v2/command/reboot/' + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({user_id: siteId + tag})
    })
    return await f.json()
}

export async function sendShellCmd(backendFetch, siteId, cmd) {
    const f = await backendFetch(appConfig.REACT_APP_HOST + '/api/v2/command/shell-command/' + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({type: "shell", data: {command: cmd}})
    })
    const r = await f.json()
    return r
}

export async function sendRevSSHCmd(backendFetch, siteId, port, tag, open) {
    const f = await backendFetch(appConfig.REACT_APP_HOST + "/api/v2/command/rev-ssh/" + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({tag: tag == "bootloader" ? "BL" : "", port: port, open: open ? 1 : 0})
    })
    const r = await f.json()
    return r
}

export async function probeDevice(backendFetch, siteId, probeParams) {
    const f = await backendFetch(appConfig.REACT_APP_HOST + '/api/v2/command/generic/' + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
            type: "probe_device",
            data: {
                protocol: probeParams.protocol,
                device_class: probeParams.device_class,
                device_type: probeParams.device_type,
                address: probeParams.address !== "" ? probeParams.address : null,
                port: probeParams.port,
                slave: probeParams.slave,
                baudrate: probeParams.baudrate,
                parity: probeParams.parity,
                stopbits: probeParams.stopbits,
                timeout: 180
            }
        })
    })
    const r = await f.json()

    if (r === "UNHANDLED") {
        return {
            success: false,
            status_code: 500,
            info: "The current firmware version of the box does not support device probing.",
            device: null
        }
    } else if (r.msg === "b'Timeout'") {
        return {success: false, status_code: 500, info: "The probe timed out.", device: null}
    }
    return JSON.parse(r)
}

export async function getARPOutput(backendFetch, siteId) {
    const f = await backendFetch(appConfig.REACT_APP_HOST + '/api/v2/command/arp/' + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({type: "arp_output"})
    })
    const r = await f.json()
    return r
}


export async function sendManualOverrideCommand(backendFetch, siteId, action, gridFeedInLimit) {
    const f = await backendFetch(appConfig.REACT_APP_HOST + '/api/v2/command/force-action/' + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({action: action, grid_feed_in_limit: gridFeedInLimit ? 1 : 0})
    })
    const r = await f.text()
    return r
}

export async function sendManualOverrideClear(backendFetch, siteId) {
    const f = await backendFetch(appConfig.REACT_APP_HOST + '/api/v2/command/clear-action/' + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"}
    })
    const r = await f.text()
    return r
}

export async function fetchSiteData(backendFetch, siteId) {
    const response = await backendFetch(appConfig.REACT_APP_HOST + "/api/v2/sites/" + siteId)
    return await response.json();
}

export async function fetchDeviceDetail(backendFetch, siteId, deviceId) {
    const f = await backendFetch(appConfig.REACT_APP_HOST + '/api/v2/command/generic/' + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
            type: "device_detail",
            data: {"device_id": deviceId}
        })
    })
    return await f.json()
}

export async function addDeviceRequest(backendFetch, siteId, device) {
    const f = await backendFetch(appConfig.REACT_APP_HOST + "/api/v2/command/add-device/" + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({"config": device})
    })
    if (f.status !== 200) {
        console.error(f)
        throw new Error('Device add failed')
    }
    const r = await f.json()
    const newDevice = JSON.parse(r)
    return newDevice
}

export async function removeDeviceRequest(backendFetch, siteId, deviceId) {
    const f = await backendFetch(appConfig.REACT_APP_HOST + "/api/v2/command/remove-device/" + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({"config": deviceId})
    })
    await f.json()
}

export async function saveDeviceRequest(backendFetch, siteId, edits) {
    const f = await backendFetch(appConfig.REACT_APP_HOST + "/api/v2/command/set-device/" + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({"updates": Object.values(edits)})
    })
    await f.json()
}

export async function fetchJournalctl(backendFetch, siteId, tag, range) {
    const f = await backendFetch(appConfig.REACT_APP_HOST + "/api/v2/command/journal-ctl/" + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
            tag: tag,
            range: range,
        })
    })
    const r = await f.json()
    return processJournalctl(r)
}

function processJournalctl(text) {
    const lines = text.split('\n')
    const result = []
    for (var i = 0; i < lines.length - 1; i++) {
        const message = JSON.parse(lines[i])

        const substr = message.MESSAGE.substr(0, 30)
        if (substr === "CMD: {'command': 'journalctl -" || substr === "shell {'command': 'journalctl ") {
            continue
        }

        result.push(message)
    }

    return result
}

export async function fetchBufferedState(backendFetch, siteId, since) {
    const response = await backendFetch(appConfig.REACT_APP_HOST + "/api/v2/command/fetch-buffered/" + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
            data: {"state_index": "control-loop", "since": since}
        })
    })
    const newDataPoint = await response.json();
    if (newDataPoint.msg === "[COMMAND]: b'Timeout'" || newDataPoint === "UNHANDLED" || newDataPoint.length === 0) return null;
    return newDataPoint
}

export async function fetchState(backendFetch, siteId, stateIndex) {
    const f = await backendFetch(appConfig.REACT_APP_HOST + '/api/v2/command/generic/' + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({type: "state", data: {state_index: stateIndex}})
    })
    const r = await f.json()
    return r
}

export async function fetchBufferedMetering(backendFetch, siteId, device_id, since) {
    const response = await backendFetch(appConfig.REACT_APP_HOST + "/api/v2/command/device-metering-buffered/" + siteId, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
            data: {"device_id": device_id, "since": since}
        })
    })
    const newDataPoint = await response.json();
    if (newDataPoint.msg === "[COMMAND]: b'Timeout'" || newDataPoint === "UNHANDLED" || newDataPoint.length === 0) return null;
    return newDataPoint
}